
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CouponCollapse extends Vue {
  // Data
  isShow = false;

  // Methods
  toggle(): void {
    this.isShow = !this.isShow;
  }

  beforeEnter(e: HTMLElement): void {
    e.style.height = '0';
  }

  enter(e: HTMLElement): void {
    e.style.height = `${e.scrollHeight}px`;
  }

  afterEnter(e: HTMLElement): void {
    e.style.height = '';
  }

  beforeLeave(e: HTMLElement): void {
    e.style.height = `${e.scrollHeight}px`;
  }

  leave(e: HTMLElement): void {
    setTimeout(() => {
      e.style.height = '0';
    }, 0);
  }
}
